<template>
  <v-row>
    <v-col cols="12" class="mx-auto" interviews>
      <v-card class="elevation-0">
        <Paging
          :resourceSettings="resourceSettings"
          :resource="interviews"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>

          <v-row>
            <v-col md="4" cols="12" FILTERS>
              <DateField 
                :modelValue="appointment_from_date" 
                label="Appointment from"
                @update:modelValue="(value) => { appointment_from_date = value; applyFilter() }"
                icon="calendar_today"
              />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
              <DateField 
                :modelValue="appointment_to_date" 
                label="Appointment to"
                @update:modelValue="(value) => { appointment_to_date = value; applyFilter() }"
                icon="calendar_today"
              />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Attended"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="attended"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Accepted"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="accepted"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Rejected"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="rejected"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.stop="$emit('openDialog', 'interview')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <listInterviews
          @copyS="clipboardSuccessHandler"
            @editResource="(name, model) => $emit('editResource', name, model)"
            @deleteResource="(name, model) => $emit('deleteResource', name, model)"
            v-if="interviews.data && interviews.data.length > 0"
            :interviews="interviews"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { format } from "timeago.js";
import Paging from "@/components/Paging";
import listInterviews from "./listInterviews.vue";
import DateField from '@/components/partials/DateField'

export default {
  components: { Paging, listInterviews, DateField },
  props: ["interviews"],
  data() {
    return {

      page: 1, 

      statuses: [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        },
      ],

      // @s filters
      appointment_from_date: null,
      appointment_to_date: null,
      attended: null,
      accepted: null,
      rejected: null,
      // @e filters

      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.appointment_from_date) {
        filter += `&appointment_from_date=${this.appointment_from_date}`
      }

      if(this.appointment_to_date) {
        filter += `&appointment_to_date=${this.appointment_to_date}`
      }

      if(this.attended != null) {
        filter += `&attended=${this.attended}`
      }

      if(this.accepted != null) {
        filter += `&accepted=${this.accepted}`
      }

      if(this.rejected != null) {
        filter += `&rejected=${this.rejected}`
      }

      return filter;
    },
    applyFilter() {
      this.loadResource()
    },
    clipboardSuccessHandler() {
      this.$emit('copyS')
    },
    getFormat(d) {
      return format(d);
    },
    formatDateToCurrentLocale(date) {
      let new_date = new Date(date);
      return [
        new_date.toLocaleDateString(this.arabic ? "ar" : "en", {
          day: "numeric",
          year: "numeric",
          month: "short",
        }),
        new_date.toLocaleTimeString(this.arabic ? "ar" : "en"),
      ];
    },
    firstLettersName(name) {
      const split_names = name.split(" ");

      if (split_names.length > 1) return (split_names[0][0] + split_names[1][0]).toUpperCase();

      return (split_names[0][0] + split_names[0][1]).toUpperCase();
    },
    loadResource() {
      this.$emit("loadResource", "interviews", "interviews", this.buildFilter(), this.page);
    },
    pageByNumber(page) {
      this.page = page
      this.$emit("pageByNumber", "interviews", "interviews", page);
    },
  },
};
</script>
